import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { TimePlanningBalance, TimePlanningBalancesByPeriod } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { InjectHoverProvider } from 'modules/core/lib/hoverContext'

// TODO: We won't need contractVersions anymore once bank of hours is released
// eslint-disable-next-line factorial/no-allowed-mobx-collections
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { usePermissions } from 'modules/shift_management/hooks/usePermissions'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import EmployeeCellContent from './EmployeeCellContent'
import EmployeeInfoCell from './EmployeeInfoCell'
import usePlannedHours from './usePlannedHours'

interface Props {
  shiftsRow: ShiftsRow
  contractVersions: ContractVersions
  balances?: TimePlanningBalance
  periodBalances?: TimePlanningBalancesByPeriod[]
}

const EmployeeCell = ({ shiftsRow, contractVersions, balances, periodBalances }: Props) => {
  const [open, toggle] = useToggle(false)
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasBankOfHoursEnabled = hasFeatureFlag(
    ShiftManagementFeatureFlags.DEV_TIME_PLANNING_BALANCES_IN_SHIFTS
  )
  const hasOverPlannedAlertEnabled = hasFeatureFlag(
    ShiftManagementFeatureFlags.DEV_SHIFT_MANAGEMENT_OVER_PLANNED_ALERT
  )
  const { color, isOverMaximum, plannedHoursTooltipCopy } = usePlannedHours(
    shiftsRow,
    balances,
    periodBalances
  )
  const [{ canManageShifts }] = usePermissions()
  const showOverPlannedAlert = canManageShifts && hasOverPlannedAlertEnabled

  if (hasBankOfHoursEnabled)
    return (
      <InjectHoverProvider>
        <Box background="grey000White" flexDirection="row" height="full">
          {showOverPlannedAlert && (
            <Tooltip.Alt
              attachment="top center"
              targetAttachment="bottom center"
              open={open}
              toggle={toggle}
              label={plannedHoursTooltipCopy}
            >
              <Box width="s12" height="full">
                <Box width="s6" height="full">
                  <Box background={color} width={open ? 's6' : 's4'} height="full" />
                </Box>
              </Box>
            </Tooltip.Alt>
          )}
          <Box padding="s8" gap="s8" justifyContent="spaceBetween" flexGrow>
            <EmployeeInfoCell
              shiftsRow={shiftsRow}
              balances={balances}
              isOverMaximum={isOverMaximum}
              plannedHoursTooltipCopy={plannedHoursTooltipCopy}
            />
          </Box>
        </Box>
      </InjectHoverProvider>
    )

  // TODO: To remove this and the related components in favour of the ones above
  // once Bank of Hours is released
  return (
    <InjectHoverProvider>
      <Box
        background="grey000White"
        flexDirection="row"
        justifyContent="spaceBetween"
        height="full"
        padding="s8"
        gap="s8"
      >
        <EmployeeCellContent shiftsRow={shiftsRow} contractVersions={contractVersions} />
      </Box>
    </InjectHoverProvider>
  )
}

export default observer(EmployeeCell)
